import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-confirmar-alteracoes-modal',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './confirmar-alteracoes-modal.component.html',
  styleUrl: './confirmar-alteracoes-modal.component.css'
})
export class ConfirmarAlteracoesModalComponent {
  @Input() erros?: {erro:string};
  @Output() eventoModal = new EventEmitter<string | undefined>();

  public fecharModal(): void {
    this.eventoModal.emit()
  }

  public confirmar(): void {
    this.eventoModal.emit("confirmar");
  }

  public cancelarAlteracao(): void {
    this.eventoModal.emit("cancelar");
  }
}
